<div
  class="image-dialog"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="(config.title || config.alt || '') + ' Image Dialog'"
  (click)="handleCloseClick()"
  (keyup.enter)="handleCloseClick()">
  <!-- laoding -->
  <div *ngIf="!imageLoaded" class="image-dialog__loading flex flex-column p-8">
    <app-spinner size="huge"> </app-spinner>
  </div>

  <!-- image -->
  <img
    class="image-dialog__image"
    [src]="config.src"
    [title]="config.title || ''"
    [alt]="config.alt || ''"
    [attr.aria-label]="config.title || ''"
    (load)="handleImageLoaded()" />

  <!-- close -->
  <button
    type="button"
    class="image-dialog__close"
    app-pin-button
    buttonType="dark"
    size="large"
    icon="times"
    aria-label="Close"
    matTooltip="Close"
    [attr.aria-label]="'Close Dialog'"
    matTooltipPosition="left"></button>
</div>
